import { Lightning02 } from "@untitledui/icons";

/**
 * Explains what the workspace template is for, above the Risks/Policies tabs.
 * The portrait is anchored to the banner's top-right and bleeds past its edges,
 * so the card clips it.
 */
export const WorkspaceDefaultsBanner = () => (
  <div className="relative flex items-center gap-8 overflow-hidden rounded-2xl bg-gradient-to-b from-[#2e1f3a] to-[#3e2356] px-8 pt-8 pb-10">
    <div className="relative z-10 flex min-w-0 flex-1 max-w-[560px] flex-col justify-center gap-2">
      <div className="flex items-center gap-1.5">
        <Lightning02 aria-hidden="true" className="w-5 h-5 shrink-0 text-primary_on-brand" />
        <p className="text-md font-medium text-primary_on-brand">Set the defaults new merchants start with</p>
      </div>
      <p className="text-sm text-secondary_on-brand">
        Choosing which risks to monitor and how to handle them is hard to get right from scratch. Set your recommended
        risks, policies, and default messages here, and every new merchant your workspace owns starts with them already
        in place, ready to keep or adjust.
      </p>
    </div>

    <img
      src="/safety/workspace-defaults-banner.png"
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute -top-[107px] right-6 h-[350px] w-[389px] select-none object-cover opacity-80"
    />
  </div>
);
